
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            제품 관리 - 브랜드 {{ $route.query.brand_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.brand_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='brand_kor_name'>브랜드 한글명<span class="pointTextRed"> * </span></label>
              <input
                type='text'
                class="Admin_PageDetail_inputText"
                id = 'brand_kor_name'
                maxLength="30"
                placeholder = "브랜드 한글명을 입력해 주세요."
                v-model="formData.brandKorName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.brandKorNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='brand_eng_name'>브랜드 영문명<span class="pointTextRed"> * </span></label>
              <input
                type='text'
                class="Admin_PageDetail_inputText"
                id = 'brand_eng_name'
                maxLength="30"
                placeholder = "브랜드 영문명을 입력해 주세요."
                v-model="formData.brandEngName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.brandEngNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='brand_explnation'>브랜드 설명<span class="pointTextRed"> * </span></label>
              <textarea
                class="Admin_PageDetail_Textarea"
                id = 'brand_explnation'
                maxLength="1500"
                placeholder = "브랜드 설명을 입력해 주세요."
                v-model="formData.brandExplnation"
              ></textarea>
            </div>
            <p class="Admin_ErrorBox">{{errorData.brandExplnationError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='brand_activate'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="brand_activate"
                v-model="formData.brandActivate"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">브랜드 배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>배너 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1920 x 600px</p>
                <label for='brand_banner_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.brand_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'brand_banner_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeBannerImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_RollingPc">
                  <img
                    :src="formData.brandBannerImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.brandBannerImageURL"
                    alt="배너 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.brandBannerImageURLError}}</p>
              </div>
            </div>

            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>로고 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">
                  사이즈 : 1000 x 1000px <br/>
                  배경없는 png만 가능!
                </p>
                <label for='brand_logo_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.brand_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'brand_logo_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeLogoImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_Square">
                  <img
                    :src="formData.brandLogoImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.brandLogoImageURL"
                    alt="로고 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.brandLogoImageURLError}}</p>
              </div>
            </div>

            <div class="Admin_imgBanner_Box"> <!-- 여기 하버되는 배경이미지인데, 로고 이미지 복붙함 -->
              <div class="Admin_imgBanner_TextBox">
                <p>로고 배경 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">
                  사이즈 : 1400 x 840px <br/> <!-- 여기는 사이즈 바꿔둔거라서 그대로 두면 됩니다 -->
                  로고없는 브랜드 배경이미지
                </p>
                <label for='brand_logo_hover' class="Admin_imgBanner_Btn">
                  {{ $route.query.brand_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'brand_logo_hover'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeLogoHover"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_BrandBg"> <!-- 여기는 클래스명 바꿔둔거라서 그대로 두면 됩니다 -->
                  <img
                    :src="formData.brandLogoHoverURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.brandLogoHoverURL"
                    alt="브랜드 배경 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.brandLogoHoverURLError}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_brand_one,
  insert_brand,
  update_brand
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminBrandManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        brandKorName: '',
        brandEngName: '',
        brandExplnation: '',
        brandActivate: 1,
        brandBannerImage: '',
        brandLogoImage: '',
        brandLogoHover: '',
        brandBannerImageURL: '',
        brandLogoImageURL: '',
        brandLogoHoverURL: ''
      }),
      errorData: ref({
        brandKorNameError: '',
        brandEngNameError: '',
        brandExplnationError: '',
        brandBannerImageURLError: '',
        brandLogoImageURLError: '',
        brandLogoHoverURLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeBannerImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.brandBannerImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.brandBannerImageURL = reader.result
        }
      }
    },
    changeLogoImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.brandLogoImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.brandLogoImageURL = reader.result
        }
      }
    },
    changeLogoHover: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.brandLogoHover = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.brandLogoHoverURL = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.brandKorName === '') {
        this.errorData.brandKorNameError = '브랜드 한글명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.brandKorNameError = ''
      }
      if (this.formData.brandEngName === '') {
        this.errorData.brandEngNameError = '브랜드 영문명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.brandEngNameError = ''
      }
      if (this.formData.brandExplnation === '') {
        this.errorData.brandExplnationError = '브랜드 설명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.brandExplnationError = ''
      }
      if (this.formData.brandBannerImageURL === '') {
        this.errorData.brandBannerImageURLError = '브랜드 배너 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.brandBannerImageURLError = ''
      }
      if (this.formData.brandLogoImageURL === '') {
        this.errorData.brandLogoImageURLError = '브랜드 로고 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.brandLogoImageURLError = ''
      }
      if (this.formData.brandLogoHoverURL === '') {
        this.errorData.brandLogoHoverURLError = '로고 배경 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.brandLogoHoverURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.brand_ID === undefined) {
          insert_brand(
            this.formData.brandKorName,
            this.formData.brandEngName,
            this.formData.brandBannerImage,
            this.formData.brandLogoImage,
            this.formData.brandLogoHover,
            this.formData.brandExplnation
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminBrandManagement'
          })
        } else {
          update_brand(
            this.$route.query.brand_ID,
            this.formData.brandKorName,
            this.formData.brandEngName,
            this.formData.brandBannerImage,
            this.formData.brandLogoImage,
            this.formData.brandLogoHover,
            this.formData.brandExplnation,
            this.formData.brandActivate
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminBrandManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.brand_ID !== undefined) {
      get_brand_one(this.$route.query.brand_ID).then((result) => {
        this.formData.brandKorName = result[0].brand_kor_name
        this.formData.brandEngName = result[0].brand_eng_name
        this.formData.brandExplnation = result[0].brand_explnation
        this.formData.brandActivate = result[0].brand_activate
        this.formData.brandBannerImageURL = result[0].brand_banner_image
        this.formData.brandLogoImageURL = result[0].brand_logo_image
        this.formData.brandLogoHoverURL = result[0].brand_logo_hover
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ProductManagement/AdminBrandManagementAdd.vue